import React, { useState, useEffect } from 'react';
import { getResultsLinks } from '../lib/dataService';
import { BarChart3, ExternalLink, History } from 'lucide-react';

export const PREVIOUS_STATS_URL = 'http://ciba.web.geniussports.com/competitions/?cu=CYBA/schedule';

export const STATS_LEAGUES = [
  { key: 'U13', label: 'U13 League', divisions: ['Boys', 'Girls'] },
  { key: 'U15', label: 'U15 League', divisions: ['Boys', 'Girls'] },
  { key: 'U16', label: 'U16 League', divisions: ['Boys', 'Girls'] },
  { key: 'U19', label: 'U19 League', divisions: ['Boys', 'Girls'] },
  { key: 'Senior Men', label: 'Senior Men', divisions: [] },
  { key: 'Senior Women', label: 'Senior Women', divisions: [] },
  { key: 'Corporate', label: 'Corporate League', divisions: [] },
];

function SeasonLinks({ links }) {
  if (links.length === 0) return <p className="results-empty">Coming soon</p>;
  return (
    <ul className="results-links">
      {links.map((l) => (
        <li key={l.id}>
          <a href={l.url} target="_blank" rel="noreferrer" className="results-link" data-testid="results-season-link">
            <span className="results-season">{l.season}</span>
            <span className="results-label">{l.label || 'Results & Stats'}</span>
            <ExternalLink size={13} />
          </a>
        </li>
      ))}
    </ul>
  );
}

export default function ResultsPage() {
  const [links, setLinks] = useState([]);

  useEffect(() => {
    getResultsLinks().then(setLinks).catch(() => setLinks([]));
  }, []);

  const forGroup = (league, division) =>
    links.filter((l) => l.league === league && (division ? l.division === division : true));

  return (
    <div className="static-page">
      <div className="page-hero">
        <div className="container">
          <span className="page-hero-label">Cayman Islands Basketball Association</span>
          <h1>Results &amp; Stats</h1>
        </div>
      </div>
      <div className="container section" data-testid="results-page">
        <p className="results-intro">
          Follow every CIBA league — schedules, results, standings and player stats. Select your league below.
        </p>
        <div className="results-grid">
          {STATS_LEAGUES.map((lg) => (
            <div key={lg.key} className="results-card" data-testid={`results-card-${lg.key.toLowerCase().replace(/\s+/g, '-')}`}>
              <h2 className="results-card-title"><BarChart3 size={19} /> {lg.label}</h2>
              {lg.divisions.length > 0 ? (
                <div className="results-divisions">
                  {lg.divisions.map((d) => (
                    <div key={d} className="results-division">
                      <h3>{d}</h3>
                      <SeasonLinks links={forGroup(lg.key, d)} />
                    </div>
                  ))}
                </div>
              ) : (
                <SeasonLinks links={forGroup(lg.key, null)} />
              )}
            </div>
          ))}
        </div>

        <div className="results-previous" data-testid="previous-seasons-note">
          <History size={20} />
          <div>
            <h3>Previous Seasons Stats</h3>
            <p>
              Looking for results and stats from earlier seasons? Visit our archive on{' '}
              <a href={PREVIOUS_STATS_URL} target="_blank" rel="noreferrer" data-testid="previous-seasons-link">
                Genius Sports <ExternalLink size={12} style={{ display: 'inline' }} />
              </a>.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}
